import {SVG} from '../../../../../constants/assetLists';

export const ANNOUNCEMENT_TYPES = [
  {value: 'Regular', title: 'שוטף', icon: SVG.regularAnnouncementIcon},
  {value: 'Error', title: 'תקלה', icon: SVG.redTriangleIcon},
  {value: 'Menu', title: 'תפריט', icon: SVG.menuTypeIcon},
  {value: 'Training', title: 'הדרכה', icon: SVG.tutorialsActiveIcon},
  {
    value: 'Administration',
    title: 'אדמיניסטרציה',
    icon: SVG.settingBlackIcon,
  },
  {value: 'Regulation', title: 'רגולציה', icon: SVG.administrationSmallIcon},
  {value: 'Notice', title: 'לידיעה', icon: SVG.exclamationCircleIcon},
  {value: 'Quick', title: 'מהירה', icon: SVG.quickTypeIcon},
  {value: 'Reservation', title: 'שולחן', icon: SVG.tableIcon},
];

export const TIMING_TYPES = [
  {value: 'default', key: 'default', title: 'ללא תזמון - דיפולט'},
  {value: 'allDay', key: 'all_day', title: 'לכל היום'},
  {
    value: 'sunday',
    key: 'by_day_and_time',
    title: 'לפי תאריך ושעה (ביום ראשון בשעה 08:00)',
  },
  {
    value: 'sundayToTuesday',
    key: 'between_days_and_hours',
    title: 'בין ימים ושעות(בין ראשון לשלישי בין 08:00 - 09:00)',
  },
  {
    value: 'everyday',
    key: 'daily_at_fixed_time',
    title: 'תזמון כל יום בשעה קבועה',
  },
  {value: 'custom', key: 'custom', title: 'תזמון מותאם'},
];

export const FILES_INPUT = [
  {
    id: 'media',
    name: 'files',
    accept: 'image/*, video/*',
    icon: SVG.cameraIcon,
  },
  {
    id: 'documents',
    name: 'files',
    accept:
      'application/pdf, application/msword, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xls,.xlsx',
    icon: SVG.fileIcon,
  },
];
